import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Header from "components/organisms/header";
import Footer from "components/organisms/footer";
import SectionHero from "components/organisms/sectionHero";
import Form from "./Form";
import FormContent from "components/organisms/formContent/index.jsx";
import FormFieldset from "components/molecules/formFieldset/index.jsx";
import { fetchVehicleParameter } from "actions/vehicle";
import INTERNAL_API_URL from "helpers/internalApiUrl";
import fetch from "isomorphic-fetch";
import "./styles.scss";

class BringUsedVehicle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      success: false,
      error: false,
    };
  }

  handleSubmit(values) {
    this.props.request(values);
  }

  componentDidMount() {
    this.props.fetch("brand");
    this.props.fetch("model");
    this.props.fetch("engine");
  }

  render() {
    const { brands, models, engines, isFetching } = this.props;

    const handleSubmit = (data) => {
      this.setState({ submitting: true, error: false, success: false });

      const form = new FormData();
      for (let key in data) {
        form.append(key, data[key]);
      }

      form.append(
        "vehicle",
        `${brands.find((b) => b.id === data.brand_id)?.name} ${
          models.find((m) => m.id === data.model_id)?.name
        } ${engines.find((e) => e.id === data.engine_id)?.name}`
      );

      const inputs = document.querySelectorAll('input[type="file"]');
      inputs[0].files[0] && form.append("file_0", inputs[0].files[0]);
      inputs[1].files[0] && form.append("file_1", inputs[1].files[0]);
      inputs[2].files[0] && form.append("file_2", inputs[2].files[0]);

      fetch(`${INTERNAL_API_URL}/used/sell`, {
        method: "POST",
        body: form,
      })
        .then(() => {
          this.setState({ submitting: false, success: true });
        })
        .catch((e) => {
          console.error(e);
          this.setState({ error: true, submitting: false });
        });
    };

    return (
      <div>
        <Helmet>
          <title>
            Te traemos el usado que quieras de Buenos Aires a Mendoza -
            Territorio Yacopini
          </title>
          <meta
            name="description"
            content="Traemos el usado que te interese de Buenos Aires a Mendoza."
          />
        </Helmet>
        <Header />
        <SectionHero style="blue">
          <h1>
            ¿El usado está en Buenos Aires?
            <br /> Te lo traemos a Mendoza.
          </h1>
        </SectionHero>

        {(isFetching === true || this.state.submitting) && (
          <FormContent>
            <FormFieldset>
              <h3>Cargando...</h3>
            </FormFieldset>
          </FormContent>
        )}

        {this.state.error === true && (
          <FormContent>
            <FormFieldset>
              <h3>Hubo un error enviando tu pedido.</h3>
              Por favor intentalo nuevamente más tarde.
            </FormFieldset>
          </FormContent>
        )}

        {!this.state.submitting && !this.state.success && (
          <Form
            brands={brands}
            models={models}
            engines={engines}
            handleSubmit={handleSubmit}
          />
        )}

        {this.state.success === true && (
          <FormContent>
            <FormFieldset>
              <h3>Solicitud enviada.</h3>
              Te estaremos contactando para que nos cuentes más sobre tu
              vehículo y evaluar la compra.
            </FormFieldset>
          </FormContent>
        )}
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    brands: state.vehicle.brands,
    models: state.vehicle.models,
    engines: state.vehicle.engines,
    isFetching: state.vehicle.isFetching,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch: (parameter) => {
      dispatch(fetchVehicleParameter(parameter));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BringUsedVehicle);
